import { SearchObject } from "app/common/Model/SearchObject";
import { exportExcelSalesReport } from "app/services/InvoiceItemService";
import { reportSales } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

export default class ReportSalesStore {
  listDataSales = null;
  searchReportSales = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentId: null,
    staffId: null,
    serviceId: null,
    drugId: null
  }
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchSales = (searchReportSales) => {
    this.searchReportSales = {
      ...this.searchReportSales,
      ...searchReportSales,
    };
    this.pagingReportSales();
  }

  pagingReportSales = async () => {
    let { departmentId, staffId, positionId, serviceId, groupserviceId, drugId, groupdrugId, treamentId, ...ortherData } = this.searchReportSales;
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    if (positionId) {
      ortherData.positionId = positionId?.id;
    }
    if (serviceId) {
      ortherData.serviceId = serviceId?.id;
    }
    if (drugId) {
      ortherData.drugId = drugId?.id;
    }
    if (Array.isArray(groupdrugId)) {
      ortherData.groupdrugId = groupdrugId.map(item => item?.id);
    }
    if (Array.isArray(groupserviceId)) {
      ortherData.groupserviceId = groupserviceId.map(item => item?.id);
    }
    if (treamentId) {
      ortherData.treamentId = treamentId?.id;
    }
    return await reportSales({ ...ortherData })
      .then(({ data }) => {
        this.listDataSales = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo doanh số có lỗi");
      });
  };

  handleExportExcelSalesReport = async (searchObj) => {
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportExcelSalesReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_DOANH_SO.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const { staffId, departmentId, serviceId, drugId, ...rest } = rawSearch;
    return {
      ...rest,
      staffId: staffId?.id || null,
      departmentId: departmentId?.id || null,
      serviceId: serviceId?.id || null,
      drugId: drugId?.id || null,
    };
  };

  resetStore = () => {
    this.listData = null
    this.searchFee = { ...new SearchObject(), fromDate: new Date(), toDate: new Date() }

  }
}